<app-tool-button text="Permisos" i18n-text (click)="this.onPermissionClick();" color="has-color-orange" icon="fa-lock" *ngIf="this.auth.IsSuperUser()">
</app-tool-button>
